/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useStyletron} from 'baseui'
import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {
  ALIGN,
  HeaderNavigation,
  StyledNavigationItem as NavigationItem,
  StyledNavigationList as NavigationList,
} from 'baseui/header-navigation'
import {StyledLink} from 'baseui/link'
import {Avatar} from 'baseui/avatar'
import TourModal from '../../features/role-selector/tour-modal'

import {assets, routes} from '../../utils/config'
import HeaderAuthMenu from './header-auth-menu'
import HeaderMobileMenu from './header-mobile-menu'
import MobileWarning from '../../features/role-selector/moblie-warning'

const GameHeader = () => {
  const [useCss, theme] = useStyletron()
  const user = useSelector(state => state.firestore?.data?.user)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(state => !state)
  }

  return (
    <>
      <HeaderNavigation
        overrides={{
          Root: {
            style: ({$theme}) => ({
              borderBottomWidth: 0,
              justifyContent: 'space-between',
              paddingLeft: $theme.sizing.scale400,
              paddingRight: $theme.sizing.scale400,
              paddingTop: $theme.sizing.scale100,
              paddingBottom: $theme.sizing.scale300,
              [$theme.mediaQuery.large]: {
                // paddingLeft: $theme.sizing.scale800,
                paddingRight: $theme.sizing.scale700,
              },
            }),
          },
        }}
      >
        <Block display="flex" alignItems="center">
          <StyledLink
            $as={Link}
            to={routes.roleSelector.url}
            className={useCss({textDecoration: 'none'})}
          >
            <Block
              as="img"
              src={assets.logoByLRF.location}
              overrides={{
                Block: {
                  style: ({$theme}) => ({
                    cursor: 'pointer',
                    height: '3rem',
                    paddingTop: $theme.sizing.scale100,
                    [$theme.mediaQuery.large]: {
                      height: '5rem',
                      // paddingTop: 0,
                    },
                  }),
                },
              }}
            />
          </StyledLink>
        </Block>
        <NavigationList $align={ALIGN.right}>
          <NavigationItem
            className={useCss({display: 'none', [theme.media.medium]: {display: 'block'}})}
          >
            <HeaderAuthMenu>
              <Avatar
                name={user.email}
                size={'scale1400'}
                src={
                  'https://firebasestorage.googleapis.com/v0/b/sotsc-platform-dev.appspot.com/o/sotsc-public%2Fimages%2Fui%2Fhud-player.svg?alt=media&token=26abc53e-d058-4663-a66e-308e588cf00b'
                }
                overrides={{
                  Initials: {
                    style: ({$theme}) => ({
                      fontWeight: 900,
                      [$theme.media.small]: {},
                      [$theme.media.medium]: {},
                    }),
                  },
                }}
              />
            </HeaderAuthMenu>
          </NavigationItem>
          <NavigationItem
            className={useCss({display: 'block', [theme.media.medium]: {display: 'none'}})}
          >
            <Button type="button" kind="tertiary" onClick={toggleMobileMenu}>
              <FontAwesomeIcon icon={isMobileMenuOpen ? 'times' : 'bars'} />
            </Button>
          </NavigationItem>
        </NavigationList>
      </HeaderNavigation>
      <HeaderMobileMenu isMobileMenuOpen={isMobileMenuOpen} toggleMobileMenu={toggleMobileMenu} />
    </>
  )
}

export default GameHeader
